<div class="row">
    <div class="dialog-title">
        <span class="text-fw-700">Payment instruction | </span>Please select from available balance or trades
    </div>
</div>

<div class="content">
    <div class="d-md-block d-none">
        <div class="row justify-content-between mb-2 available-amount">
            <div class="check-box">
                <mat-checkbox disableRipple class="greengo" (change)="checkChangAvailableBalance()" [checked]="checkAvailableBalance">Available balance: {{paymentModel.currency.code}} {{paymentModel.availableBalance | transformNumber}}</mat-checkbox>
            </div>
            <div class="">
                <p class="text-dark-blue">Total amount selected: {{paymentModel.currency.code}} {{totalSelected | transformNumber}}</p>
            </div>
        </div>
    </div>

    <div class="d-block d-md-none">
        <div class="row">
            <div class="check-box">
                <mat-checkbox disableRipple class="greengo" (change)="checkChangAvailableBalance()" [checked]="checkAvailableBalance">Available balance: </mat-checkbox>
            </div>
            <div class="ml-auto">
                {{paymentModel.currency.code}} {{paymentModel.availableBalance | transformNumber}}
            </div>

        </div>
        <div class="row">
            <div class="total-line-mobile">
                Total amount selected:
            </div>
            <div class="ml-auto">
                {{paymentModel.currency.code}} {{totalSelected | transformNumber}}
            </div>

        </div>
    </div>

    <div class="mb-4 trades-table">
        <table>
            <thead>
                <tr>
                    <th>
                    </th>
                    <th>
                        <div class="d-flex align-items-center table-title">
                            <a class="title-column">Trade Reference</a>&nbsp;
                            <i *ngIf="sortTrade" class="pull-left fa" [ngClass]="{
                                      'fa-angle-up': sortTrade === 'desc',
                                      'fa-angle-down': sortTrade === 'asc'
                                    }" (click)="sortTradeList('tradeReference')"></i>
                            <div class="sort-column" *ngIf="!sortTrade" (click)="sortTradeList('tradeReference')">
                                <i class="pull-left fa fa-angle-up"></i>
                                <i class="pull-left fa fa-angle-down"></i>
                            </div>
                        </div>
                    </th>
                    <th>
                        <a class="title-column">Currency sell amount</a>
                    </th>
                    <th>
                        <a class="title-column">Currency buy amount</a>
                    </th>
                    <th>
                        <div class="d-flex align-items-center table-title">
                            <a class="title-column">Value date</a>&nbsp;
                            <i *ngIf="sortDate" class="pull-left fa" [ngClass]="{
                                          'fa-angle-up': sortDate === 'desc',
                                          'fa-angle-down': sortDate === 'asc'
                                        }" (click)="sortTradeList('valueDate')"></i>
                            <div class="sort-column" *ngIf="!sortDate" (click)="sortTradeList('valueDate')">
                                <i class="pull-left fa fa-angle-up"></i>
                                <i class="pull-left fa fa-angle-down"></i>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of tradeList" [class.row-checked]="item.checked">
                    <td>
                        <mat-checkbox disableRipple class="greengo" (change)="checkItem($event, item)" [checked]="item.checked"></mat-checkbox>
                    </td>
                    <td>{{ item.tradeReference }}</td>
                    <td>
                        <span class="{{ item.soldOfferInfo.currencyCode | flagIcon }} icon-flag"></span>&nbsp;{{ item.soldOfferInfo.quantity | transformNumber }}
                    </td>
                    <td>
                        <span class="{{ item.boughtOfferInfo.currencyCode | flagIcon }} icon-flag"></span>&nbsp;{{ item.boughtOfferInfo.quantity | transformNumber }}
                    </td>
                    <td>{{ item.valueDate | date: 'dd/MM/yyyy' }}</td>
                </tr>
            </tbody>
        </table>

    </div>
    <div class="row">
        <div class="col-4 pl-0">
            <button class="btn btn-lg btn-block btn-greengo-o" (click)="goBack()">Go back</button>
        </div>
        <div class="col-4 ml-auto pr-0">
            <button class="btn btn-lg btn-block" [ngClass]="{
                    'btn-greengo': totalSelected >= paymentModel.amount,
                    'btn-inactive': totalSelected < paymentModel.amount
                  }" (click)="nextTabPayment()" npFocusOutClicked>
                Continue
            </button>
        </div>
    </div>
</div>